import { render, staticRenderFns } from "./TableOrderHistory.vue?vue&type=template&id=1e9fa448&scoped=true"
import script from "./TableOrderHistory.vue?vue&type=script&lang=js"
export * from "./TableOrderHistory.vue?vue&type=script&lang=js"
import style0 from "./TableOrderHistory.vue?vue&type=style&index=0&id=1e9fa448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9fa448",
  null
  
)

export default component.exports